import clsx from 'clsx';
import type { SectionHeaderProps } from './sectionHeader.types';

export function SectionHeader({ title, subtitle, actions, className }: SectionHeaderProps) {
    return (
        <div className={clsx('flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between', className)}>
            <div className="min-w-0">
                <h2 className="font-montserrat text-lg font-semibold text-raro-gray-900 sm:text-xl">
                    {title}
                </h2>
                {subtitle && (
                    <p className="mt-1 text-sm text-raro-gray-500 font-montserrat">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </div>
    );
}

export default SectionHeader;
